import type { CampaignData, WordpressPage } from '@benzinga/content-manager';
import type { ScreenerTrade } from '@benzinga/screener-widget';
import type { CallToActionProps } from '@benzinga/ui';

type FloatingCampaign = Pick<
  CampaignData,
  'cta_description' | 'cta_text' | 'cta_title' | 'image_url' | 'url' | 'utm_action'
> & { image_width?: number };

interface FloatingPlacement {
  devices: string;
  geo_target: string;
  id: string;
  type: 'campaign';
}

interface ScreenerCampaigns {
  floating: {
    campaigns: Record<string, FloatingCampaign>;
    placements: FloatingPlacement[];
  };
}

const SPONSOR_ID = 'screener-sponsor';
const SPONSOR_LOGO = 'https://cdnwp-s3.benzinga.com/wp-content/uploads/2026/09/11122041/SageTrader-Logo-dark.png';
const SPONSOR_CTA_URL = 'https://www.benzinga.com/go/sagetrader-screener-cta';
const SPONSOR_FLYOUT_URL = 'https://www.benzinga.com/go/sagetrader-screener-flyout';
const SPONSOR_TRADE_URL = 'https://www.benzinga.com/go/sagetrader-screener-table';

export const SCREENER_PRESENTED_BY =
  'https://cdnwp-s3.benzinga.com/wp-content/uploads/2026/09/11112529/SageTrader-Logo-Light.png';
export const SCREENER_PRESENTED_BY_LINK = SPONSOR_CTA_URL;

export const SCREENER_TRADE: ScreenerTrade = {
  buttonLabel: 'Trade with SageTrader',
  columnLabel: 'Trade with SageTrader',
  url: SPONSOR_TRADE_URL,
};

export const SCREENER_CTA = {
  button_text: 'Trade with SageTrader',
  description:
    'Start from just $100 deposit with free platform, mobile app, real-time data and zero commissions. Every trade supports the SageTrader Foundation.',
  image_url: SPONSOR_LOGO,
  image_width: 180,
  title: 'Ready to trade these stocks commission-free?',
  url: SPONSOR_CTA_URL,
  utm_action: 'Screener Sponsor: SageTrader',
  utm_category: 'Lead Click',
  utm_label: 'Primary CTA',
} satisfies CallToActionProps;

export const SCREENER_CAMPAIGNS: WordpressPage['campaigns'] = {
  floating: {
    campaigns: {
      [SPONSOR_ID]: {
        cta_description:
          'Get SageTrader Pro with commissions at $0.0003/share for your first month. Plus custom routing, ECN rebates, locates and options trading. Start trading with $3,000.',
        cta_text: 'Trade with SageTrader Pro',
        cta_title: 'Ready for more control over your trades?',
        image_url: SPONSOR_LOGO,
        image_width: SCREENER_CTA.image_width,
        url: SPONSOR_FLYOUT_URL,
        utm_action: SCREENER_CTA.utm_action,
      },
    },
    placements: [{ devices: 'all-devices', geo_target: '', id: SPONSOR_ID, type: 'campaign' }],
  },
} satisfies ScreenerCampaigns;
